<span fxLayout="row" fxLayoutAlign="start center">
  <button mat-stroked-button (click)="removeFile()" *ngIf="this.showRemove" [disabled]="disabled">
    {{'pdfWrapper.cancelUploadLbl' | transloco}}
  </button>
  <button mat-icon-button (click)="showPages()" *ngIf="!pdfWrapper.showAll"
    title="{{'pdfWrapper.showCompleteDocumentLbl' | transloco}}" [disabled]="disabled">
    <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-file-exclamation"></mat-icon>
  </button>
  <button mat-icon-button (click)="zoom(0.1)" *ngIf="this.showZoomIn" title="{{'common.zoomInBtn' | transloco}}" [disabled]="disabled">
    <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-search-plus"></mat-icon>
  </button>
  <button mat-icon-button (click)="zoom(-0.1)" *ngIf="this.showZoomOut" title="{{'common.zoomOutBtn' | transloco}}" [disabled]="disabled">
    <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-search-minus"></mat-icon>
  </button>
  <button id="pdfPrint" mat-icon-button (click)="printpdf()" *ngIf="this.showPrint" title="{{'common.printBtn' | transloco}}" [disabled]="disabled">
    <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-print"></mat-icon>
  </button>
  <button mat-icon-button (click)="saveFile()" *ngIf="this.showSave" title="{{'common.download' | transloco}}" [disabled]="disabled">
    <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-file-download"></mat-icon>
  </button>
</span>
